import React from "react";
import styled from "styled-components";
import Input from "./index";

const BigInput = ({
  label,
  value,
  onChange,
  type,
  placeholder,
  disabled,
  className,
  style,
  error,
  ...rest
}) => {


  return (
    <InputContainer>
      <Label>{label}</Label>
      <Input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        error={error}
        size="large"
        {...rest}
      />  
      <Error error={error}>{error}</Error>
    </InputContainer>
  );
};

export const Error = styled.p`
  color: #c54600;
  font-size: 18px !important;
  font-weight: 400;
  height: 24px;

  opacity: ${({ error }) => (error ? "1" : "0")};
`;

export const Label = styled.label`
  font-size: 24px !important;
  font-weight: 600;
`;

export const InputContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;


export default BigInput;